/**
 * Shared env config shape for client + server.
 */

export interface EnvConfig {
  PRODUCTS_API_URL: string;
  CARTS_API_URL: string;
  CHECKOUT_URL: string;
  CHECKOUT_MIDDLEWARE_URL: string;
  CAMPAIGNS_API_URL: string;
  CAMPAIGNS_TENANT_ID: string;
  FUNNELS_API_URL: string;
  FUNNELS_TENANT_ID: string;
  /** Store ID for multi-store filtering. Empty string means all stores (no filtering). */
  FUNNELS_STORE_ID: string;
  /** Google Tag Manager container ID (e.g. "GTM-XXXXXXX"). Empty string disables GTM. */
  GTM_ID: string;
  /** Public product feed URL (Google Merchant XML). Empty string disables the feeds page link. */
  PUBLIC_PRODUCT_FEED_URL: string;
  /** Public-facing base URL of the storefront (used for canonical links, OG tags). */
  BASE_URL: string;
  /** Storefront BFF base URL. On SSR prefers STOREFRONT_BFF_INTERNAL_URL when set. */
  STOREFRONT_BFF_URL: string;
  /** Auth/magic-link BFF when deployed API lags; falls back to STOREFRONT_BFF_URL. */
  STOREFRONT_AUTH_BFF_URL: string;
  /** Optional login/register hero image URL (tenant-specific). */
  LOGIN_IMAGE_URL: string;
  /**
   * Comma-separated CDN hostnames that support image resize query params
   * (e.g. `cdn.demo.dev.trafiflow.com`). Empty = pattern match `cdn.*.trafiflow.com`.
   */
  CDN_HOSTS: string;
  /** CDN origin for published locale JSON (`{tenant}/{store}/locales/...`). */
  CDN_BASE_URL: string;
  /** Deploy/runtime fingerprint used to invalidate stale browser runtime state after deploys. */
  RUNTIME_VERSION: string;
}

export const DEV_ENV_DEFAULTS: EnvConfig = {
  PRODUCTS_API_URL: 'http://products.dev.trafiflow.local',
  CARTS_API_URL: 'http://carts.dev.trafiflow.local',
  CHECKOUT_URL: 'http://localhost:8082',
  CHECKOUT_MIDDLEWARE_URL: 'http://localhost:8088',
  CAMPAIGNS_API_URL: 'http://localhost:3010',
  CAMPAIGNS_TENANT_ID: 'dev',
  FUNNELS_API_URL: 'http://funnels.dev.trafiflow.local',
  // Canonical demo tenant (tss-docs architecture/authentication/07-demo-scope-and-migrations.md).
  // The legacy `'dev'` tenant no longer matches the realigned funnels rows.
  FUNNELS_TENANT_ID: 'd92ca479-f9b1-471a-9544-be2a793ee155',
  FUNNELS_STORE_ID: 'demo',
  GTM_ID: '',
  PUBLIC_PRODUCT_FEED_URL: '',
  BASE_URL: 'http://localhost:8080',
  STOREFRONT_BFF_URL: '',
  STOREFRONT_AUTH_BFF_URL: '',
  LOGIN_IMAGE_URL: '',
  CDN_HOSTS: '',
  CDN_BASE_URL: 'https://cdn.demo.dev.trafiflow.com',
  RUNTIME_VERSION: 'local-dev',
};
